module.exports = __webpack_public_path__ + "img/img1.782bb127.png";